import { useState } from 'react';

import { useSmsOptInFailedPopup } from './components/sms-opt-in-failed-popup/sms-opt-in-failed-popup.hook';
import { useSmsOptedOutWarningPopup } from './sms-opted-out-warning-popup.hook';

export const useGetSmsOptedOutWarningPopup = () => {
  const { open: openSmsOptOutWarningPopup } = useSmsOptedOutWarningPopup();
  const { open: openSmsOptInFailedPopup } = useSmsOptInFailedPopup();
  const [isSmsOptInFailed, setIsSmsOptInFailed] = useState(false);

  const handleSmsOptInAttempt = () => {
    setIsSmsOptInFailed(true);
  };

  const openBlockedPhoneNumberPopup = () => {
    if (isSmsOptInFailed) {
      openSmsOptInFailedPopup();
    } else {
      openSmsOptOutWarningPopup({ onConfirm: handleSmsOptInAttempt });
    }
  };

  return openBlockedPhoneNumberPopup;
};
